import { createContext, useContext } from 'react';

import { ClientContactForm } from '../../hooks/useClientFormModalContext';

interface OrganizationFormFlowContextDataType {
  selectedContact: ClientContactForm;
  setSelectedContact: (contact: ClientContactForm) => void;
}

export const OrganizationFormFlowContext = createContext<
  OrganizationFormFlowContextDataType | undefined
>(undefined);

/**
 * Context only for the client organization/company creation/edit flow
 */
export const useOrganizationFormFlowContext = () => {
  const context = useContext(OrganizationFormFlowContext);

  if (!context) {
    throw new Error(
      '"useOrganizationFormFlowContext" can only be used under OrganizationFormFlowContextProvider',
    );
  }
  return context;
};
